export default {"src":"/_next/static/media/play.019db664.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};